import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { LoadBaseRdm ,LoadDeclSchema} from '@shared-store/base.action';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { Observable } from 'rxjs';


type UserBasedOnLicenseActivityGroup = 'Trader' | 'Broker' | 'Customs Warehouse';

const rdmKeys = [
  "phone.country.code",
  "kc-profile-treatment-recommended-actions",
  "ics-label-bondedArea",
  "umscodes3225",
  "financial.deposit.expiryMonth",
  "vehiclemake",
  "kc-dec-raf-control-outcome",
  "kc-dec-raf-control-result",
  "kc-dec-raf-document-category",
  "kc-dec-raf-further-action",
  "kc-dec-raf-item-status",
  "kc-dec-raf-operation-reason",
  "kc-dec-raf-operation-type",
  "kc-dec-raf-reason-for-no-check"
	

];

@Injectable({
  providedIn: "root",
})
export class CommonRdmService {
  private userType: UserBasedOnLicenseActivityGroup;

  constructor(private http: HttpClient,private store: Store)  {}

  public loadCommonRdm() :void {
    this.store.dispatch(new LoadBaseRdm(rdmKeys, "commonRdm"));
  }

  public loadConsumerRdm() : void {
    this.store.dispatch(new LoadDeclSchema());
  }

  public loadAdminRdm() : void {
    this.store.dispatch(new LoadDeclSchema());
  }

  getNewSchemaType(type: string): Observable<any> {
    const url = environment.baseUrl + environment.assetsEndPoint + `/assets/schemas/intellig/${type}/new-schema.json`;
    return this.http.get(url);
  }
  
  getDeclarationsSchema(file: string): Observable<any> {
    const url = environment.baseUrl + environment.assetsEndPoint + `/assets/schemas/ics/${file}`;
    return this.http.get(url);
  }

  public loadrefTypeCode(res:any):any[]{
    const refList:any=[];
    for (const clazz in res) {
      for (const field in res[clazz]) {
        if (!_.isEmpty(res[clazz][field]['refTypeCode'])) {
          const rdmReftypes = res[clazz][field]['refTypeCode'].split(',');
          rdmReftypes.forEach((refType:any) => {
            refList.push(refType);
          });
        }
      }
    }
    return refList;
  }

  public loadparentRefType(res:any):any[]{
    const refList:any=[];
    for (const clazz in res) {
      for (const field in res[clazz]) {
        if (!_.isEmpty(res[clazz][field]['refTypeCode']) && !_.isEmpty(res[clazz][field]['parentRefType'])) {
          const splitRdmReftype = [{ ref: res[clazz][field]['refTypeCode'].split(','), parent: res[clazz][field]['parentRefType'].split(',') }]
          splitRdmReftype.forEach(element => {
            if (Array.isArray(element.ref)) {
              element.ref.forEach((r) => {
                refList.push(r);
              });
            } else {
              refList.push(element.ref);
            }

          });
        }
      }
    }
    return refList;
  }
  getClmBrokers(brokerCode: string): Observable<any> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      '/clm' +
      environment.wso2amApiVersion +
      '/api/v1/authorization/search/Broker';
    return this.http.get(url, { params: { brokerCode, historyView: 'N', status: 'active' } });
  }
  
  getClmTraders(traderCode: string): Observable<any> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      '/clm' +
      environment.wso2amApiVersion +
      '/api/v1/authorization/search/Trader';
    return this.http.get(url, { params: { traderCode, historyView: 'N', status: 'active' } });
  }
  setUserTypeBOLAG(userType: UserBasedOnLicenseActivityGroup) {
    this.userType = userType;
  }

  getClmData(id: string): Observable<any> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      '/clm' +
      environment.wso2amApiVersion +
      `/api/v1/customers/customerlist/license/activitygroup/${id}`;
    return this.http.get(url);
  }
}
